<template>
  <div class="container min-vh-100">
    <nav class="back-btn mt-3 mb-3" v-if="showNetpay" @click="back">
      <button class="btn-outline-primary">
        <i class="fas fa-chevron-left"></i>
      </button>
    </nav>
    <form @submit="handleForm" v-if="!showNetpay">
      <div class="payment d-flex flex-column justify-content-center mb-3">
        <img
          src="https://latinoseguros.com.mx/sitio2021/wp-content/uploads/2020/11/latino-seguros-quienes-somos.jpg"
          alt=""
        />
        <div class="payment__text">
          <p class="text-center">Total</p>
          <h2 class="text-center">${{ amount }}</h2>
        </div>
      </div>

      <div class="group__container d-flex flex-wrap justify-content-between">
        <div class="form-group col-6">
          <label for="">Nombre</label>
          <input type="text" name="Nombre" class="form-control" />
        </div>
        <div class="form-group col-6">
          <label for="">Apellido</label>
          <input type="text" name="Apellido" class="form-control" />
        </div>
        <div class="form-group col-6">
          <label for="">Correo electrónico</label>
          <input type="email" name="Correo" class="form-control" />
        </div>
        <div class="form-group col-6">
          <label for="">Teléfono</label>
          <input type="number" name="Telefono" min="0" class="form-control" />
        </div>

        <div class="col-12 mb-3">
          <small>Domicilio</small>
        </div>

        <div class="form-group col-6">
          <label for="">Calle y número</label>
          <input type="text" name="Calle" class="form-control" />
        </div>
        <div class="form-group col-6">
          <label for="">Ciudad</label>
          <input type="text" name="Ciudad" class="form-control" />
        </div>
        <div class="form-group col-6">
          <label for="">Estado</label>
          <input type="text" name="Estado" class="form-control" />
        </div>
        <div class="form-group col-6">
          <label for="">CP</label>
          <input type="text" name="CodigoPostal" class="form-control" />
        </div>

        <div class="form-group col-12 mt-3 d-flex justify-content-end">
          <button type="submit" class="btn btn-primary">
            Continuar
          </button>
        </div>
      </div>
    </form>
    <Payment class="min-vh-100" :data="userData" v-if="showNetpay" />
  </div>
</template>

<style lang="scss">
.back-btn button {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  font-size: 11px;
}
.payment {
  width: 100%;
  height: 200px;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  img {
    width: 100%;
  }

  .payment__text {
    position: absolute;
    color: white;
    z-index: 6;
    width: 100%;
  }

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(41, 41, 41, 0.664);
    backdrop-filter: blur(2px);
    z-index: 0;
  }
}

.group__container {
  // max-width: 350px;
  margin: 0 auto;
}
</style>

<script>
import Payment from "../../componentes/Netpay";
import { Base64 } from "js-base64";
import { format, form } from "../../assets/helpers";

export default {
  components: { Payment },

  data: () => ({
    amount: 0,
    nombre: "",
    email: "",
    data: Object,
    showNetpay: false,
  }),

  methods: {
    handleForm(e) {
      e.preventDefault();
      const data = form.build(e.target);

      // Validación
      if (!Object.values(data).every((item) => item != "")) {
        alert("Todos los campos son obligatorios");
        return;
      }

      Object.entries(data).forEach((item) => {
        this.userData[item[0]] = item[1];
      });

      this.showNetpay = true;
    },

    back() {
      this.showNetpay = false;
    },
  },

  computed: {
    userData() {
      return {
        IdBanco: "30",
        IdApp: this.data.IdApp,
        Referencia: this.data.ReferenciaPago,
        Monto: this.data.Monto,
        PromocionMeses: "000000",
        NumeroPoliza: this.data.Poliza,
        TipoMoneda: "MXN",
        Pais: "MX",
      };
    },
  },

  created() {
    const params = this.$route.query.p;
    const decoded = JSON.parse(Base64.decode(params));
    this.data = decoded.Datospago;
    this.amount = format.money(this.data.Monto);

    // Login anónimo
    // Token anónimo
    const usuario = {
        password: "Latino2021*",
        userName: "userApiLeads"
    };
    this.$store.dispatch("login", {usuario, redir: true}).then(() => {});
  },
};
</script>